/* Sevine Dumont · M1 header + announcement bar, F1 footer helpers. Owner: header-footer group.
   - <sd-ann>: one message at a time, slides every N seconds (feedback 01-10 K1: no close button).
   - <sd-hdr>: solid state on scroll (overlay header), mega panel closes after a click, mobile drawer with level 2.
   - [data-sd-loc]: small disclosure for country / language. */
(function () {
  if (window.SDChrome) return;
  window.SDChrome = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function store(get, key, val) {
    try {
      if (get) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  /* ---------- Wishlist helpers (same key as the cards and the product page) ---------- */
  function wishRead() { try { var l = JSON.parse(window.localStorage.getItem('sd-wishlist') || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
  function wishWrite(l) { try { window.localStorage.setItem('sd-wishlist', JSON.stringify(l)); } catch (e) { /* storage blocked */ } wishCount(); }
  function wishCount() {
    var n = wishRead().length;
    document.querySelectorAll('[data-sd-wish-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k.indexOf('no_decimals') > -1) return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k.indexOf('comma') > -1) return v.replace('.', ',');
      return v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
    var tmp = document.createElement('span'); tmp.innerHTML = out; return tmp.textContent;
  }

  /* ---------- Announcement bar ---------- */
  if (!customElements.get('sd-ann')) {
    customElements.define('sd-ann', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-sd-ann-track]');
        this.slides = Array.from(this.querySelectorAll('.sd-ann__slide'));
        this.index = 0;
        if (this.slides.length < 2 || reduce) return;
        var ms = parseInt(this.dataset.interval, 10) || 5000;
        var start = () => { this.timer = setInterval(() => this.go(this.index + 1), ms); };
        var stop = () => clearInterval(this.timer);
        this.addEventListener('mouseenter', stop);
        this.addEventListener('mouseleave', start);
        this.addEventListener('focusin', stop);
        this.addEventListener('focusout', start);
        start();
      }
      go(i) {
        this.index = (i + this.slides.length) % this.slides.length;
        this.track.style.transform = 'translateX(' + (-100 * this.index) + '%)';
        this.slides.forEach((s, n) => {
          var on = n === this.index;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
          var a = s.querySelector('a');
          if (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); }
        });
      }
    });
  }

  /* ---------- Header ---------- */
  if (!customElements.get('sd-hdr')) {
    customElements.define('sd-hdr', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.sd-hdr-section');
        this.drawer = this.querySelector('[data-sd-hdr-drawer]');
        this.burger = this.querySelector('[data-sd-hdr-burger]');

        // Overlay: total height (header + quick row) for the negative margin
        var overlay = this.classList.contains('sd-hdr--overlay') && this.section;
        var measure = () => { if (overlay) this.section.style.setProperty('--sd-hdr-total', this.offsetHeight + 'px'); };
        measure();
        window.addEventListener('resize', measure, { passive: true });
        // K3: the quick-link row only shows at the very top; it hides as soon as you scroll (hysteresis against jumping)
        // 06-10 (Jesse, naar Hang Eleven): wit zodra je scrolt; de rij schuift weg als je naar beneden scrolt
        // en komt terug als je omhoog scrolt
        var scrolled = false, lastY = window.scrollY;
        var onScroll = () => {
          var y = window.scrollY;
          if (overlay) this.classList.toggle('is-solid', y > 0);
          var next = scrolled;
          if (y <= 10) next = false;
          else if (y > lastY + 2) next = true;
          else if (y < lastY - 2) next = false;
          if (Math.abs(y - lastY) > 2 || y <= 10) lastY = y;
          if (next !== scrolled) { scrolled = next; this.classList.toggle('is-scrolled', scrolled); measure(); }
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });

        // Fix 03-10: mega panel with hover intent. Pure :hover closed the panel as soon as the mouse left
        // the narrow link on the way to the panel (diagonal move). Now leaving waits CLOSE_MS, and switching
        // to another top link waits SWITCH_MS, so a diagonal path over "Bags" does not swap the panel.
        var CLOSE_MS = 400, SWITCH_MS = 160;
        var current = null, openTimer = 0, closeTimer = 0;
        this.setPanel = (item) => {
          if (current && current !== item) current.classList.remove('is-open');
          current = item || null;
          if (current) current.classList.add('is-open');
          this.classList.toggle('is-panel-open', !!current);
        };
        this.classList.add('sd-hdr--js');
        this.querySelectorAll('.sd-hdr__item').forEach((item) => {
          var mega = item.classList.contains('sd-hdr__item--mega');
          item.addEventListener('pointerenter', (e) => {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(closeTimer);
            clearTimeout(openTimer);
            if (current === item) return;
            // A link that still has keyboard focus would keep its own panel open (focus-within)
            var focused = document.activeElement;
            if (focused && focused.closest && focused.closest('.sd-hdr__item') && !item.contains(focused)) focused.blur();
            openTimer = setTimeout(() => this.setPanel(mega ? item : null), current ? SWITCH_MS : 0);
          });
          // While another panel is open, only switch once the mouse rests here: every move restarts the wait
          item.addEventListener('pointermove', (e) => {
            if (e.pointerType !== 'mouse' || !current || current === item) return;
            clearTimeout(openTimer);
            openTimer = setTimeout(() => this.setPanel(mega ? item : null), SWITCH_MS);
          });
          item.addEventListener('pointerleave', (e) => {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(openTimer);
            closeTimer = setTimeout(() => this.setPanel(null), CLOSE_MS);
          });
        });

        // Close the hover panel right after a click inside it
        this.querySelectorAll('.sd-hdr__panel a').forEach((a) => {
          a.addEventListener('click', () => {
            this.setPanel(null);
            this.classList.add('is-closing');
            setTimeout(() => this.classList.remove('is-closing'), 400);
          });
        });
        // Escape closes an open panel (keyboard)
        this.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape') return;
          if (this.classList.contains('is-menu-open')) { this.closeDrawer(); this.burger.focus(); return; }
          var item = document.activeElement && document.activeElement.closest('.sd-hdr__item--mega');
          this.setPanel(null);
          if (item) { item.querySelector('.sd-hdr__link').focus(); this.classList.add('is-closing'); setTimeout(() => this.classList.remove('is-closing'), 300); }
        });

        // Mobile drawer
        if (this.burger && this.drawer) {
          this.burger.addEventListener('click', () => (this.classList.contains('is-menu-open') ? this.closeDrawer() : this.openDrawer()));
          this.drawer.querySelectorAll('[data-sd-hdr-close]').forEach((b) => b.addEventListener('click', () => this.closeDrawer()));
          window.matchMedia('(min-width: 1024px)').addEventListener('change', (m) => { if (m.matches) this.closeDrawer(); });
        }

        // Wishlist count (06-10: the heart is a link to /pages/wishlist, the panel is optional)
        wishCount();
        window.addEventListener('storage', (e) => { if (e.key === 'sd-wishlist') wishCount(); });
        document.addEventListener('sd:wishlist:changed', wishCount);
        document.addEventListener('click', (e) => {
          if (e.target.closest && e.target.closest('[data-sd-ib-wish], [data-sdp-wish], [data-sd-c2-wish]')) setTimeout(wishCount, 0);
        });

        // Wishlist panel
        this.wish = this.querySelector('[data-sd-wish]');
        this.wishBtn = this.querySelector('[data-sd-wish-open]');
        if (this.wish && this.wishBtn) {
          this.wishBtn.addEventListener('click', () => this.openWish());
          this.wish.querySelectorAll('[data-sd-wish-close]').forEach((b) => b.addEventListener('click', () => this.closeWish()));
          this.wish.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeWish(); });
          this.wish.addEventListener('click', (e) => {
            var rm = e.target.closest('[data-sd-wish-remove]');
            if (!rm) return;
            var list = wishRead().filter((h) => h !== rm.getAttribute('data-sd-wish-remove'));
            wishWrite(list);
            document.querySelectorAll('[aria-pressed][data-sd-ib-wish="' + rm.getAttribute('data-sd-wish-remove') + '"], [aria-pressed][data-sdp-wish="' + rm.getAttribute('data-sd-wish-remove') + '"]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
            this.renderWish();
          });
          wishCount();
          // Other scripts write the list without an event: refresh the count after any heart click
          document.addEventListener('click', (e) => {
            if (e.target.closest && e.target.closest('[data-sd-ib-wish], [data-sdp-wish], [class*="wish"]')) setTimeout(wishCount, 0);
          });
          window.addEventListener('storage', (e) => { if (e.key === 'sd-wishlist') wishCount(); });
        }
      }
      openWish() {
        this.closeDrawer();
        this.wish.hidden = false;
        requestAnimationFrame(() => this.wish.classList.add('is-open'));
        this.wishBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('sd-hdr-locked');
        this.renderWish();
        var c = this.wish.querySelector('.sd-wish__close');
        if (c) c.focus({ preventScroll: true });
      }
      closeWish() {
        if (!this.wish || this.wish.hidden) return;
        this.wish.classList.remove('is-open');
        this.wishBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('sd-hdr-locked');
        setTimeout(() => { this.wish.hidden = true; }, reduce ? 0 : 250);
        this.wishBtn.focus({ preventScroll: true });
      }
      renderWish() {
        var ul = this.wish.querySelector('[data-sd-wish-list]');
        var empty = this.wish.querySelector('[data-sd-wish-empty]');
        var list = wishRead();
        empty.hidden = list.length > 0;
        ul.innerHTML = '';
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var fmt = ul.getAttribute('data-money-format') || '${{amount}}';
        list.forEach((h) => {
          var li = document.createElement('li');
          li.className = 'sd-wish__item';
          ul.appendChild(li);
          fetch(root + 'products/' + encodeURIComponent(h) + '.js').then((r) => (r.ok ? r.json() : null)).then((p) => {
            if (!p) { li.remove(); return; }
            var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
            var a = document.createElement('a');
            a.className = 'sd-wish__link';
            a.href = p.url || (root + 'products/' + h);
            if (img) { var im = document.createElement('img'); im.src = img; im.alt = ''; im.width = 80; im.height = 100; im.loading = 'lazy'; a.appendChild(im); }
            var t = document.createElement('span'); t.className = 'sd-wish__name'; t.textContent = p.title; a.appendChild(t);
            var pr = document.createElement('span'); pr.className = 'sd-wish__price'; pr.textContent = money(p.price, fmt); a.appendChild(pr);
            var rm = document.createElement('button');
            rm.type = 'button'; rm.className = 'sd-wish__remove'; rm.setAttribute('data-sd-wish-remove', h);
            rm.setAttribute('aria-label', 'Remove ' + p.title); rm.textContent = 'Remove';
            li.appendChild(a); li.appendChild(rm);
          }).catch(() => li.remove());
        });
      }
      openDrawer() {
        this.closeWish();
        this.drawer.hidden = false;
        requestAnimationFrame(() => this.drawer.classList.add('is-open'));
        this.classList.add('is-menu-open');
        this.burger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('sd-hdr-locked');
      }
      closeDrawer() {
        if (!this.drawer || this.drawer.hidden) return;
        this.drawer.classList.remove('is-open');
        this.classList.remove('is-menu-open');
        this.burger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('sd-hdr-locked');
        setTimeout(() => { this.drawer.hidden = true; }, reduce ? 0 : 250);
      }
    });
  }

  /* ---------- Footer accordions: open columns on desktop, closed accordions on mobile ---------- */
  (function () {
    var mq = window.matchMedia('(min-width: 750px)');
    function sync() {
      document.querySelectorAll('[data-sd-ftr-acc]').forEach(function (d) { d.open = mq.matches; });
    }
    function block(e) { if (mq.matches && e.target.closest('[data-sd-ftr-acc] > summary')) e.preventDefault(); }
    document.addEventListener('click', block);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
    mq.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  /* ---------- Localization disclosure ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-sd-loc-toggle]');
    document.querySelectorAll('[data-sd-loc-toggle][aria-expanded="true"]').forEach(function (t) {
      if (t === toggle) return;
      t.setAttribute('aria-expanded', 'false');
      var l = document.getElementById(t.getAttribute('aria-controls'));
      if (l) l.hidden = true;
    });
    if (!toggle) return;
    var list = document.getElementById(toggle.getAttribute('aria-controls'));
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (list) list.hidden = open;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-sd-loc-toggle][aria-expanded="true"]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      var l = document.getElementById(t.getAttribute('aria-controls'));
      if (l) l.hidden = true;
      t.focus();
    });
  });
})();
